import { render, staticRenderFns } from "./offer-favourites.vue?vue&type=template&id=804a7e6e&scoped=true&"
import script from "./offer-favourites.vue?vue&type=script&lang=js&"
export * from "./offer-favourites.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "804a7e6e",
  null
  ,true
)

export default component.exports